module.exports = __WEBPACK_EXTERNAL_MODULE_html2canvas_pro__;